import { useEffect, useState } from "react";
import { DEFAULT_TABLE_PAGES } from "../utils/constants";
import useNearScreen from "./useNearScreen";

const usePagination = ({
  rowsPerPageValue = DEFAULT_TABLE_PAGES,
  onCallBackNextPage = () => ({}),
  distance = "700px",
}) => {
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageValue);
  const [page, setPage] = useState(0);
  const [lastKey, setLastKey] = useState(null);

  const { isNearScreen, fromRef, loadLastItem, onChangeLoadLastItem } =
    useNearScreen({
      distance,
      once: false,
    });

  const onRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const onPageChange = (newPage) => {
    setPage(newPage);
    if (newPage > page) onFetchNextPage();
  };

  const onChangeLastKey = (lastKey) => {
    setLastKey(lastKey);
  };

  const onFetchNextPage = async () => {
    if (loadLastItem) return;
    await onCallBackNextPage();
  };

  useEffect(() => {
    if (isNearScreen && !loadLastItem) onCallBackNextPage();

    // eslint-disable-next-line
  }, [isNearScreen]);

  return {
    rowsPerPage,
    page,
    lastKey,
    onRowsPerPageChange,
    onPageChange,
    onChangeLastKey,
    onFetchNextPage,
    isNearScreen,
    fromRef,
    loadLastItem,
    onChangeLoadLastItem,
  };
};

export { usePagination };
